import { Elements } from "@stripe/react-stripe-js";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import SaveCardForm from "../../pages/billing/paymentMethod/SaveCardForm";
import { useGetUserProfileQuery } from "../../features/users/usersApi";
import {
  getStripePromise,
  normalizeOrganizationCurrency,
} from "../../utils/stripe";

const apiUrl = import.meta.env.VITE_API_URL;

interface AddCardProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

const AddCard: React.FC<AddCardProps> = ({ setShow, show }) => {
  const [clientSecret, setClientSecret] = useState("");
  const { data: profileData } = useGetUserProfileQuery(undefined, {
    skip: !show,
  });

  const organizationCurrency = profileData?.data?.organization?.currency;
  const stripeCurrency = normalizeOrganizationCurrency(organizationCurrency);
  const stripePromise = useMemo(
    () => getStripePromise(organizationCurrency),
    [organizationCurrency],
  );

  useEffect(() => {
    if (!show || !organizationCurrency) {
      return;
    }

    const generateClientKey = async () => {
      try {
        setClientSecret("");
        const accessToken = localStorage.getItem("accessToken");
        const result = await axios.post(
          `${apiUrl}stripe/create-client-key`,
          {},
          {
            headers: {
              Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
            },
          },
        );
        setClientSecret(result.data?.data);
      } catch (error) {
        console.error("Error creating Stripe setup intent:", error);
      }
    };

    generateClientKey();
  }, [show, organizationCurrency]);

  return (
    <Offcanvas
      show={show}
      onHide={() => setShow(!show)}
      placement={"end"}
      style={{ width: "700px" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="settings-header px-2 mb-2">
          Add a new card
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mx-2">
          {clientSecret && organizationCurrency && (
            <Elements
              key={stripeCurrency}
              stripe={stripePromise}
              options={{
                loader: "auto",
                clientSecret: clientSecret,
                appearance: { theme: "stripe" },
              }}
            >
              <SaveCardForm onClose={() => setShow(false)}></SaveCardForm>
            </Elements>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddCard;
